"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const faqsbrand01 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-faqsbrand01` : '') + (description ? ` desc-faqsbrand01` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-faqsbrand01"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-faqsbrand01"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29 38.14C5.29 56.29 20 71 38.15 71s32.86-14.71 32.86-32.86S56.29 5.29 38.14 5.29 5.29 20 5.29 38.14Z",
    fill: "#FFC599",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.76 42.09c-.55 0-1-.45-1-1v-2.94c0-2.28 1.44-4.32 3.59-5.08a7.77 7.77 0 0 0 4.98-9.06 7.752 7.752 0 0 0-8.44-5.97A7.775 7.775 0 0 0 26 25.75c0 .55-.45 1-1 1s-1-.45-1-1c0-4.97 3.72-9.14 8.66-9.7 4.93-.56 9.5 2.67 10.61 7.51a9.755 9.755 0 0 1-6.26 11.4 3.387 3.387 0 0 0-2.25 3.19v2.94c0 .55-.45 1-1 1Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.95 50.49c-.81 0-1.46.65-1.46 1.46 0 .81.65 1.46 1.46 1.46.81 0 1.46-.65 1.46-1.46 0-.81-.65-1.46-1.46-1.46Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.86 68.71C15.19 68.71 0 53.53 0 34.86S15.19 1 33.86 1s33.86 15.19 33.86 33.86-15.19 33.86-33.86 33.86v-.01Zm0-65.71C16.29 3 2 17.29 2 34.86s14.29 31.86 31.86 31.86 31.86-14.29 31.86-31.86S51.42 3 33.86 3Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = faqsbrand01;